import { createContext } from 'react'

import type { LoginPayload, User } from '@/features/auth/types'

export interface AuthContextValue {
  user: User | null
  isAuthenticated: boolean
  /** true mientras se valida una sesión persistida (recarga de página). */
  isBootstrapping: boolean
  isLoggingIn: boolean
  /**
   * SA-5 — true cuando la sesión es válida pero la organización del
   * usuario fue suspendida por un operador de plataforma (backend:
   * "Organization access is disabled."). Distinto de !isAuthenticated:
   * no se redirige a /login, se muestra una pantalla controlada
   * (ProtectedRoute) porque el token sigue siendo válido — si la
   * organización se reactiva, el acceso vuelve sin volver a iniciar sesión.
   */
  isOrganizationSuspended: boolean
  login: (payload: LoginPayload) => Promise<void>
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
